import { useOutletContext } from "react-router-dom";

import OrganizationSettingsLanguageView from "../../views/OrganizationSettingsView/OrganizationSettingsLanguageView";

export default function OrganizationSettingsLanguage() {
	const { organization } = useOutletContext();

	return <OrganizationSettingsLanguageView organization={organization} />;
}
